import { useState } from 'react';
import { Selection } from '@quero-delivery/quero-components-web';
import Tooltip from 'rc-tooltip';
import { useQueryClient } from '@tanstack/react-query';
import { usePutChangePlaceCloud } from '../../api/put-change-place-cloud';

import styles from './toogle-cloud.module.scss';
import { ConfirmationModal } from '@/_components/confirmation-modal';
import { GET_PLACE_ID } from '../../api/constants';

interface ToogleCloudProps {
  placeId: string;
  isCloud: boolean;
}

function ToggleCloud({ placeId, isCloud }: ToogleCloudProps) {
  const [isPlaceCloud, setIsPlaceCloud] = useState(isCloud);
  const [isOpenConfirmationModal, setIsOpenConfirmationModal] = useState(false);

  const queryClient = useQueryClient();

  function handleCloseConfirmationModal() {
    setIsOpenConfirmationModal(false);
  }

  const { mutate: putChangePlaceCloud, isLoading } = usePutChangePlaceCloud({
    onSuccess: () => {
      setIsPlaceCloud(prev => !prev);
      handleCloseConfirmationModal();
      queryClient.invalidateQueries({ queryKey: [GET_PLACE_ID] });
    },
  });

  return (
    <div>
      <Tooltip
        overlay={
          <b>
            Ao habilitar a gestão nuvem, somente os entregadores nuvem serão
            chamados.
          </b>
        }
        placement="top"
        mouseEnterDelay={0.5}
        overlayClassName="white-tooltip"
      >
        <div className={styles.toggleOnlyDedicate}>
          <Selection
            type="switch"
            checked={isPlaceCloud}
            onClick={() => setIsOpenConfirmationModal(true)}
            className="switch-with-colors"
          />
          <b>Gestão Nuvem</b>
        </div>
      </Tooltip>
      <ConfirmationModal
        open={isOpenConfirmationModal}
        onClose={handleCloseConfirmationModal}
        handleConfirm={() =>
          putChangePlaceCloud({
            placeId,
            isCloud: !isPlaceCloud,
          })
        }
        isLoading={isLoading}
        questionText={
          <>
            Você tem certeza que deseja{' '}
            {isPlaceCloud ? 'desabilitar' : 'habilitar'} a <b>gestão nuvem</b>{' '}
            para este estabelecimento?
          </>
        }
        title={`${isPlaceCloud ? 'Desabilitar' : 'Habilitar'} gestão nuvem`}
      />
    </div>
  );
}

export { ToggleCloud };
